import React, { useMemo } from "react";
import { SpecificationsFilter } from "./SpecificationsFilter";
import { SpecificationsTable } from "./SpecificationsTable";
import { SpecificationsLoadingDialog } from "./SpecificationsLoadingDialog";
import { SpecificationsDeleteDialog } from "./SpecificationsDeleteDialog";
import { SpecificationDeleteDialog } from "./SpecificationDeleteDialog";
import { SpecificationsFetchDialog } from "./SpecificationsFetchDialog";
import { SpecificationsGrouping } from "./SpecificationsGrouping";
import { SpecificationEditDialog } from "./specification-edit-dialog/SpecificationEditDialog";
import { useSpecificationsUIContext } from "./SpecificationsUIContext";
import { SpecificationsHolidayDialog } from "./SpecificationsHolidayDialog";
import { SpecificationsAuditOptionDialog } from "./SpecificationsAuditOptionDialog";

import { shallowEqual, useSelector } from "react-redux";
import RoomDialogPage from "../../../../../app/modules/BaseInfo/building/RoomDialogPage";
import { SpecificationRecoverDeleteDialog } from "./SpecificationRecoverDeleteDialog";
import { SpecificationsHardDeleteDialog } from "./SpecificationsHardDeleteDialog";

export function Specifications({
  showTitle,
  api,
  reduxName,
  columns,
  prepareFilter,
  filterInitialValues,
  filterFields,
  haveAccess,
  haveFullAccess,
  holiday,
  auditOption = false,
  softDelete = true,
  auditList = false,
  showRoomsAction = false,
  haveEditAction = false,
  formFields,
  haveAddAction = false,
  haveDeleteAction = false,
  haveHardDelete = false,
  isFullAccess = false,
  ObjectEditSchema
}) {
  // Specifications UI Context
  const specsUIContext = useSpecificationsUIContext();
  const specsUIProps = useMemo(() => {
    return {
      ids: specsUIContext.ids,
      parentId: specsUIContext.parentId,
      parentName: specsUIContext.parentName,
      secondParentId: specsUIContext.secondParentId,
      secondParentName: specsUIContext.secondParentName,
      showRoomsDialog: specsUIContext.showRoomsDialog
    };
  }, [specsUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state[reduxName] }),
    shallowEqual
  );
  // filterInitialValues.roleId = specsUIContext.parentId
  if (specsUIProps.parentName != "") { filterInitialValues[specsUIProps.parentName] = specsUIProps.parentId }
  if (specsUIProps.secondParentName && specsUIProps.secondParentName != "") { filterInitialValues[specsUIProps.secondParentName] = specsUIProps.secondParentId }

  return (
    <>

      <SpecificationsLoadingDialog reduxName={reduxName} />
      <SpecificationEditDialog
        showTitle={showTitle}
        api={api}
        reduxName={reduxName}
        ObjectEditSchema={ObjectEditSchema}
        formFields={formFields}
        editFormFields={formFields}
        prepareFilter={prepareFilter}
        isFullAccess={isFullAccess}
      />
      <SpecificationDeleteDialog showTitle={showTitle} api={api} reduxName={reduxName} softDelete={softDelete} />
      <SpecificationRecoverDeleteDialog showTitle={showTitle} api={api} reduxName={reduxName} softDelete={softDelete} />
      <SpecificationsDeleteDialog showTitle={showTitle} api={api} reduxName={reduxName} />
      <SpecificationsFetchDialog showTitle={showTitle} api={api} reduxName={reduxName} />
      <SpecificationsAuditOptionDialog showTitle={showTitle} api={api} reduxName={reduxName} />
      <SpecificationsHardDeleteDialog showTitle={showTitle} api={api} reduxName={reduxName} />
      <SpecificationsHolidayDialog api={api} reduxName={reduxName} />
      <div className="form margin-b-30">
        {!specsUIProps.showRoomsDialog &&
          <SpecificationsFilter
            haveAddAction={haveAddAction && isFullAccess}
            prepareFilter={prepareFilter}
            filterInitialValues={filterInitialValues}
            filterFields={filterFields}
          />}
        {specsUIProps.ids.length > 0 && (
          <>
            <SpecificationsGrouping
              haveAccess={haveAccess}
              haveFullAccess={haveFullAccess}
              holiday={holiday}
              auditOption={auditOption}
              haveHardDelete={haveHardDelete && isFullAccess}
            />
            <br />
          </>
        )}

      </div>
      {specsUIProps.showRoomsDialog && <RoomDialogPage />}
      {!specsUIProps.showRoomsDialog && <SpecificationsTable
        api={api}
        reduxName={reduxName}
        columns={columns}
        auditList={auditList}
        showRoomsAction={showRoomsAction}
        haveEditAction={haveEditAction}
        haveDeleteAction={haveDeleteAction}
        isFullAccess={isFullAccess}
      />
      }
    </>
  );
}
